import { ROUTES } from '../../constants';

/**
 * Chemins Home de MAX. **Miroir exact** de `MAX_HOME_PATHS` du SCL
 * (`shared-components-library/src/components/SharedPopups/utils.ts`) : toute
 * dérive entre les deux listes affiche les pop-ups `homeOnly` au mauvais endroit.
 */
export const MAX_HOME_PATHS: string[] = ['/', ROUTES.BASENAME, '/frontend-v2'];

/**
 * Attend le chemin **réel** de la page (`window.location.pathname`), jamais un
 * chemin relatif au basename du Router.
 */
export const isHomepage = (pathname: string): boolean =>
  MAX_HOME_PATHS.includes(pathname.replace(/\/$/, '') || '/');

export default isHomepage;
